import { ICostSummaryItem, ILineItem } from '../../CartContext.types';
import { ICustomerAppreciationDiscount } from '../../../../types/Plan';
import { useCalculateDiscountHook } from '../../../../pages/Cart/Hooks/CalculateDiscountHook';

export const useCustomerDiscountHook = (
    lineItem: ILineItem,
    discount?: ICustomerAppreciationDiscount
): ICostSummaryItem | undefined => {
    if (discount && !discount.exclusiveDiscount) {
        const amount = Number(
            useCalculateDiscountHook(
                lineItem.planSelection?.linePrice,
                discount.discountType,
                discount.discountAmount
            )
        );

        return {
            lineNumber: lineItem.lineNumber,
            itemName: `${discount.name} Discount`,
            amount: amount,
            type: 'discount'
        };
    }
};
